import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import Handsontable from 'handsontable';
import { GirderPalamService } from 'src/app/service/girder-palam.service';
import { pvGirderService } from 'src/app/three/pvGirder.service';

@Component({
  selector: 'app-side-right-cross',
  templateUrl: './side-right-cross.component.html',
  styleUrls: ['../side-right/side-right.component.scss']
})
export class SideRightCrossComponent {

  constructor(public dialogRef: MatDialogRef<SideRightCrossComponent>,
    public model: GirderPalamService,
    private girder: pvGirderService) { }

    public redraw(): void {
      this.girder.createGirder(this.model.palam());
    }

    private rowheader: string[] = [
      '横構',
      'フランジ幅',
      'フランジ厚',
      'ウェブ幅',
      'ウェブ厚',
      '離隔（外側',
      '離隔（内側',
      'ガセットプレート',
      '全体高',
      '短辺高',
      '天端幅',
      '底面幅',
      '厚さ',
    ];

    
    private dataset: any[] = [
      { name: 'Cross', value: '', unit: ''},
      {name: 'D3',        value: this.model.getDisplayValue(this.model.cross.D3, 'mm', 'D3'),       unit: this.model.getDisplayUnit('mm', 'D3')},
      {name: 'tf2',       value: this.model.getDisplayValue(this.model.cross.tf2, 'mm', 'tf2'),      unit: this.model.getDisplayUnit('mm', 'tf2')},
      {name: 'W2',        value: this.model.getDisplayValue(this.model.cross.W2, 'mm', 'W2'),       unit: this.model.getDisplayUnit('mm', 'W2')},
      {name: 'tw2',       value: this.model.getDisplayValue(this.model.cross.tw2, 'mm', 'tw2'),      unit: this.model.getDisplayUnit('mm', 'tw2')},
      {name: 's_edge',    value: this.model.getDisplayValue(this.model.cross.s_edge, 'mm', 's_edge'),   unit: this.model.getDisplayUnit('mm', 's_edge')},
      {name: 's_middle',  value: this.model.getDisplayValue(this.model.cross.s_middle, 'mm', 's_middle'), unit: this.model.getDisplayUnit('mm', 's_middle')},
      { name: 'Gusset04', value: '', unit: ''},
      { name: 'GA4', value: this.model.getDisplayValue(this.model.cross.GA4, 'mm', 'GA4'), unit: this.model.getDisplayUnit('mm', 'GA4')},
      { name: 'GD4', value: this.model.getDisplayValue(this.model.cross.GD4, 'mm', 'GD4'), unit: this.model.getDisplayUnit('mm', 'GD4')},
      { name: 'GB4', value: this.model.getDisplayValue(this.model.cross.GB4, 'mm', 'GB4'), unit: this.model.getDisplayUnit('mm', 'GB4')},
      { name: 'GC4', value: this.model.getDisplayValue(this.model.cross.GC4, 'mm', 'GC4'), unit: this.model.getDisplayUnit('mm', 'GC4')},
      { name: 'Gt4', value: this.model.getDisplayValue(this.model.cross.Gt4, 'mm', 'Gt4'), unit: this.model.getDisplayUnit('mm', 'Gt4')},
      ];

    private columns = [
      {
        data: 'unit',
        readOnly: true
      },
      {
        data: 'value',
        type: 'numeric',
        numericFormat: {
          pattern: this.model.getDisplayFormat('mm', 'D3')
        }
      }
    ];


    public hotSettings: Handsontable.GridSettings = {
      data: this.dataset,
      colHeaders: false,
      rowHeaders: this.rowheader,
      colWidths: [50, 100],
      columns: this.columns,
      allowEmpty: false,
      preventOverflow: 'horizontal',
      beforeChange: (changes, source)=>{
        for(const item of changes){
          if (item === null){
            continue
          }
          let value = parseFloat(item[3]);
          if( isNaN(value) )
            return false;
          const name: string = this.dataset[item[0]].name;
          
          const originalUnit = this.getOriginalUnit(name);
          const storageValue = this.model.getStorageValue(value, originalUnit, name);
          this.model.cross[name] = storageValue;
        }
        // 再描画
        this.redraw();
        return true;
      },
    };

  private getOriginalUnit(fieldName: string): string {
    const unitMap: any = {
      'D3': 'mm',
      'tf2': 'mm',
      'W2': 'mm',
      'tw2': 'mm',
      's_edge': 'mm',
      's_middle': 'mm',
      'GA4': 'mm',
      'GD4': 'mm',
      'GB4': 'mm',
      'GC4': 'mm',
      'Gt4': 'mm'
    };
    return unitMap[fieldName] || '';
  }
}
